export const releaseNotesDe: ReleaseNotes = [
    {
        release: "1.21.0",
        date: "2026-08-06",
        tags: [
            "Auswertungen", "Organisationen", "Zahlungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Generierung von Auswertungen in queued Job verschoben",
            }, {
                "description": "\"Support geben\"-Funktion auch in Organisations-Nutzer-Übersicht verfügbar",
            }, {
                "description": "Logo von Sozialministerium aktualisiert",
            }, {
                "description": "SEPA-Export auf pain-Version 001.001.09 aktualisiert",
            }
        ],
        fixes: []
    },
    {
        release: "1.20.0",
        date: "2026-06-24",
        tags: [
            "Auswertungen", "Antragstellung", "Statistik"
        ],
        type: "minor",
        notes: [
            {
                "description": "Verband-Filter zu Statistikmeldungen-Listing hinzugefügt",
            }, {
                "description": "\"Art des Trägers\" und \"Rechtsform des Trägers\" zu Organisationen vom Typ \"Verband\" hinzugefügt",
            }, {
                "description": "Überarbeitung Export vom Weiterleitungsvertrag",
            }, {
                "description": "Juleica-Prüfung angepasst",
            }, {
                "description": "Variablen \"Zuschuss bewilligt\" und \"Zuschuss bewilligt am\" zu E-Mailvorlagen hinzugefügt",
            }, {
                "description": "Auswertung \"Gesamtliste mit Formulardaten\" überarbeitet",
            }, {
                "description": "Auswertung \"SV21\" überarbeitet",
            }, {
                "description": "SEPA-Export pain-Version aktualisiert",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Aufrufen von \"Jugend Zählt\"",
            }, {
                "description": "Fehler beim Sortieren nach Vorgangsnummer im Statistikmeldungen-Listing behoben",
            }, {
                "description": "Fehler beim Speichern von Statistikmeldungen behoben",
            }, {
                "description": "Fehlerbehebung beim Übermitteln der Statistikdaten ans StaLa",
            }, {
                "description": "Fehlerbehebung beim Bearbeiten von Bankverbindungen",
            }, {
                "description": "Fehler beim erneuten Versenden von E-Mails behoben",
            }, {
                "description": "Fehlerbehebung beim Einloggen von Sport-Nutzer*innen",
            }
        ]
    }, {
        release: "1.19.0",
        date: "2026-04-10",
        tags: [
            "Formulare", "Statistik", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Zeichenbeschränkung (250) bei Feld 1.3 in den Formularen \"A33-1 BK\" und \"V33-1 BK\" hinzugefügt",
            }, {
                "description": "Excel-Import von Personen in Formularen verbessert",
            }, {
                "description": "Personen-Funktion \"Leitung\" aus Formular V21-1 entfernt",
            }, {
                "description": "Export-Funktion von Statistikmeldungen überarbeitet",
            }, {
                "description": "Anpassung des Namens von Statistikmeldungen bei Erstellen von Veranstaltung",
            }, {
                "description": "Hinweisfeld bei Sport-Nutzern in Nutzer-Detailseite",
            }, {
                "description": "\"LfdNr.\" zu Statistikmeldungen hinzugefügt",
            }, {
                "description": "Sortierung nach \"Vorgänge\"-Spalte in Statistikmeldung-Tabelle hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Abschicken von Statistikmeldungen",
            }, {
                "description": "Fehlerbehebung beim Übertragen von Statistikmeldungen ans StaLa",
            }, {
                "description": "Fehlerbehebung beim Exportieren von Personen in Formularen",
            }, {
                "description": "Fehlerbehebung beim Erstellen von Auswertungen",
            }, {
                "description": "Anlegen von Nutzern durch Sport-Nutzer deaktiviert",
            }, {
                "description": "Fehler bei der Berechnung des Zuschusses in Formular \"V33-1\" behoben",
            }, {
                "description": "Fehler beim Exportieren von Nutzern behoben",
            }
        ]
    }, {
        release: "1.18.2",
        date: "2026-03-13",
        tags: [
            "Statistik", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Auswertung \"LJP AA33 BK\" hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung bei der Anzeige der Historie von Statistikmeldungen",
            }
        ]
    }, {
        release: "1.18.1",
        date: "2026-03-11",
        tags: [
            "Statistik", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Auswertungen \"LJP SV32 BK\" und \"LJP SV33 BK\" hinzugefügt",
            }, {
                "description": "\"Statistik an StaLa übermitteln\"-Funktionalität überarbeitet",
            }
        ],
        fixes: []
    }, {
        release: "1.18.0",
        date: "2026-03-10",
        tags: [
            "Formulare", "Statistik", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Auswertung \"LJP SV31 BK\" hinzugefügt",
            }, {
                "description": "LJP Formulare überarbeitet",
            }, {
                "description": "KVJS Formulare überarbeitet",
            }, {
                "description": "\"Statistik an StaLa übermitteln\"-Funktionalität überarbeitet",
            }, {
                "description": "Vorgangs-Spalte in Statistikmeldungsliste eingebaut",
            }, {
                "description": "\"Letzer Login\" wird bei \"Support geben\"-Funktion nicht mehr gesetzt",
            }, {
                "description": "\"Veranstaltungsende\"-Filter in Vorgangsübersicht hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Bildungskonzept",
            }, {
                "description": "Fehlerbehebung beim \"Status ändern\"-Tool für Vorgänge",
            }, {
                "description": "Fehlerbehebung beim Prüfen der Juleica-Nummer von Personen",
            }, {
                "description": "Fehlerbehebung beim Importieren von Personen aus Excel-Dateien",
            }, {
                "description": "Fehlerhafte Links zu Statistikmeldungen behoben",
            }
        ]
    }, {
        release: "1.17.0",
        date: "2026-01-27",
        tags: [
            "Formulare", "Bildungskonzept", "Organisationen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Änderung Checkbox beim Formular LJP V21-1",
            }, {
                "description": "Platzhalter \"Ortsunabhängig\" zu Formularexport hinzugefügt",
            }, {
                "description": "Bildungskonzept-Funktionalität und -Formulare aktualisiert",
            }, {
                "description": "\"Jugend zählt\"-Menüpunkt entfernt",
            }
        ],
        fixes: [
            {
                "description": "Button ohne Funktion in Kategorieverwaltung repariert",
            }, {
                "description": "Fehlerbehebung beim Bearbeiten von Organisationsverknüpfungen von Nutzer*innen",
            }, {
                "description": "Fehlerbehebung beim Speichern von Verbänden",
            }
        ]
    }, {
        release: "1.16.0",
        date: "2026-01-20",
        tags: [
            "Sport", "Organisationen", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Beim Anlegen von neuen Jahren können Daten aus alten Jahren übernommen werden",
            }, {
                "description": "Fehlermeldungen beim Login von Sport-Nutzern konkretisiert",
            }, {
                "description": "eCore-Felder können jetzt bei \"Verbandseinstellungen\" eingetragen werden",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Anlegen von Tagen in durchgeführtem Programm",
            }, {
                "description": "Fehlerbehebung beim Exportieren von Formularen",
            }, {
                "description": "Fehlerbehebung beim Importieren von Personen aus Excel-Dateien",
            }, {
                "description": "Fehler beim Einloggen mit Sportbizz-Zugang behoben",
            }, {
                "description": "Fehlerbehebung beim Sortieren von Statistikvorgängen nach Organisationen",
            }, {
                "description": "Fehler beim Speichern von Organisationen mit Kategorien behoben",
            }
        ]
    },
    {
        release: "1.15.5",
        date: "2025-11-26",
        tags: [
            "Organisationen", "Formulare", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Logo von Sozialministerium aktualisiert",
            }, {
                "description": "Übersicht über bereits getätigte Zahlungen in Vorgangsdetailseite hinzugefügt",
            }, {
                "description": "\"Vorgang kopieren\" Funktionalität überarbeitet",
            }, {
                "description": "Name von unterschreibender Person über QR-Code im Formular hinzugefügt",
            }, {
                "description": "Import von Personen aus Excel-Dateien mit Juleica-Nummern überarbeitet",
            }, {
                "description": "Kreditorennr. zu Organisationen im Verband ID 26 hinzugefügt",
            }, {
                "description": "Kontoinhaber zu \"Gesamtliste\" und \"Gesamtliste mit Formulardaten\" Auswertungen hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim SL-Nummer-Zurücksetzen Werkzeug",
            }, {
                "description": "Fehlerbehebung im KVJS V FB Formular",
            }, {
                "description": "Fehler beim aktualisieren von Statistikdaten von Sport-Organisationen behoben",
            }
        ]
    }, {
        release: "1.15.4",
        date: "2025-11-13",
        tags: [
            "Statistik", "Nutzer", "Zahlungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "PDF-Vorschau bei Zahlungen mit SAGE-Export hinzugefügt",
            }, {
                "description": "Fehlanzeige für \"Amtliche Statistik\"-Erhebung hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung bei Excel-Export für Nutzer*innen",
            }, {
                "description": "Fehlerbehebung im KVJS V AH Formular",
            }
        ]
    }, {
        release: "1.15.3",
        date: "2025-11-04",
        tags: [
            "Nutzer"
        ],
        type: "minor",
        notes: [
            {
                "description": "Excel-Export für Nutzer*innen im Verwaltungsbereich hinzugefügt",
            }
        ],
        fixes: []
    }, {
        release: "1.15.2",
        date: "2025-10-31",
        tags: [
            "Formulare", "Vorgänge", "Zahlungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Änderungen an LJP V22-1, V31-1 und V32-1 Formularen",
            }, {
                "description": "Änderungen an Sonderzuschuss Nordbaden Formular",
            }, {
                "description": "Fehlermeldungen sind länger, aber nicht mehr dauerhaft sichtbar",
            }, {
                "description": "\"Gestartet am\"-Datum wird in Veranstaltungsübersicht angezeigt",
            }, {
                "description": "Beim Starten von Vorgängen kann ein Jahr ausgewählt werden",
            }, {
                "description": "Verband-Filter in Vorgangsübersicht hinzugefügt",
            }, {
                "description": "Bezeichnungen der Buttons in Antragsbereich überarbeitet",
            }, {
                "description": "Förderprogramm-Rechte für Veranstaltungsdaten überarbeitet",
            }, {
                "description": "Personenliste in Formularen im Antragsbereich überarbeitet",
            }, {
                "description": "Importieren von Personen aus Excel-Dateien überarbeitet",
            }, {
                "description": "Verwendungszweck-Variable \"organisation\" in Zahlungsläufen hinzugefügt",
            }, {
                "description": "Mitarbeitende werden in Statistik bei \"ehrenamtlichen Mitarbeitenden\" vorgeschlagen",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebungen bei Zahlungsläufen für Verbände mit SAGE-Anbindung",
            }, {
                "description": "Fehlerbehebung Antragsteller und Ansprechperson in Vorgangsdetailseite",
            }, {
                "description": "Fehlerbehebung beim Nutzen der Sportbizz-Anbindung",
            }, {
                "description": "Zahlungsläufe verwenden als Kontoinhaber nicht mehr den Namen der Organisation, sondern den Kontoinhaber der Bankverbindung",
            }, {
                "description": "Fehlerhafte Mailvorlagen können nicht mehr gespeichert werden",
            }
        ]
    }, {
        release: "1.15.1",
        date: "2025-10-15",
        tags: [
            "Statistik", "Formulare", "E-Mailvorlagen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Fehlermeldungen sind dauerhaft sichtbar, bis sie weggeklickt werden",
            }, {
                "description": "Veranstaltungsdaten bei den LJP-Formularen A22-1 und V22-1 überarbeitet",
            }, {
                "description": "\"E-Mailadresse bestätigen\"-Prozess überarbeitet",
            }, {
                "description": "Dokumenten-Upload bei allen LJP-Formularen überarbeitet",
            }, {
                "description": "Hinweis, wenn in Antragsbereich bei Formularen beantragter Zuschuss oder zustehender Zuschuss 0 € sind",
            }, {
                "description": "Fehlende Statistikdaten der Organisation können jetzt beim Absenden von Statistikmeldungen direkt in einem separaten Fenster ergänzt werden",
            }, {
                "description": "Fehlerhafte Variablen werden im Werkzeug \"E-Mail an Ansprechpersonen\" jetzt geprüft und verhindern den Versand",
            }
        ],
        fixes: [
            {
                "description": "Mailvorlagen versenden beim Testversand keine fremden Vorgänge mehr",
            }, {
                "description": "Fehlermeldung bei den LJP-Formularen V31-1 und V32-1 beim beantragten Zuschuss korrigiert",
            }
        ]
    }, {
        release: "1.15.0",
        date: "2025-09-24",
        tags: [
            "Statistik"
        ],
        type: "minor",
        notes: [
            {
                "description": "Statistik wird automatisch an StaLa verschickt",
            }, {
                "description": "Status von Statistikvorgängen kann gesammelt über Werkzeug geändert werden",
            }, {
                "description": "SL-Nummer kann jetzt von bestimmten Rollen zurückgesetzt werden",
            }, {
                "description": "Der Verwendungszweck eines Zahlungslaufs kann jetzt geändert werden",
            }, {
                "description": "\"Zurück zum Seitenanfang\"-Knopf hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlende Stornobemerkung wird jetzt in Antragsbereich angezeigt",
            }
        ]
    }, {
        release: "1.14.3",
        date: "2025-08-05",
        tags: [
            "Formulare"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Fehlerbehebung bei der Höhe von Filtern",
            }, {
                "description": "Fehlerbehebung in den Formularen A33-1 und V33-1 bei der Berechnung der Finanzierung",
            }
        ]
    }, {
        release: "1.14.2",
        date: "2025-08-05",
        tags: [
            "Zahlungen", "Organisationen", "Vorgänge", "E-Mailvorlagen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Auswahlkästchen beim Zahlungsjournal entfernt",
            }, {
                "description": "\"Art des Trägers\" und \"Rechtsform des Trägers\" können bei Sportbizz-Organisationen bearbeitet werden",
            }, {
                "description": "Statistische Kennnummern werden bei Sportbizz-Organisationen jetzt korrekt gesetzt",
            }, {
                "description": "Fehlerbehebung beim Verwalten von Vorgängen von Organisationen aus anderen Verbänden",
            }, {
                "description": "Fehler bei zu großem Filter-Fenster auf kleinen Bildschirmen behoben",
            }, {
                "description": "Fehlerbehebung beim Bearbeiten von Zahlungsläufen",
            }, {
                "description": "Fehlerbehebung beim Löschen von E-Mailvorlagen, mit denen bereits Mails verschickt wurden",
            }
        ]
    }, {
        release: "1.14.1",
        date: "2025-08-05",
        tags: [
            "Statistik"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Fehlerbehebung LJP SV Auswertungen",
            }
        ]
    }, {
        release: "1.14.0",
        date: "2025-08-05",
        tags: [],
        type: "minor",
        notes: [
            {
                "description": "Juleica-Nummer zu formularspezifischen Personenfelder-Typen hinzugefügt",
            }, {
                "description": "Nutzer*innen können jetzt die Spaltensichtbarkeit für sich persönlich anpassen",
            }, {
                "description": "Neue E-Mailvorlagen-Variablen \"organisationId\", \"processInternalReferenceNumber\" hinzugefügt",
            }, {
                "description": "Einheitliche Bezeichnung von Organisation (Antragsteller), Person (Ansprechperson) von Vorgängen und Kontaktperson der Organisation",
            }, {
                "description": "Interne Bearbeitungsnummer hängt jetzt an Vorgängen und nicht mehr an den Formularen",
            }, {
                "description": "Neuerstellen der Dokumente von Zahlungsläufen hinzugefügt",
            }, {
                "description": "Bei \"Lehrgangsstunden pro Tag\" dürfen nur noch halbe und ganze Tage eingegeben werden",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Sortieren von Statusbenachrichtigungen",
            }, {
                "description": "Fehlerbehebung beim Anlegen neuer Formulare, wenn Statistik nicht genutzt wird",
            }, {
                "description": "Fehlerhafte Rolle beim Anlegen neuer Nutzer*innen behoben",
            }, {
                "description": "Fehlerhaften Statusfilter in Statistikübersicht im Verwaltungsbereich korrigiert",
            }, {
                "description": "Fehlerbehebung beim Anlegen von Statistiken durch Organisationsadmins",
            }, {
                "description": "Fehlerbehebung beim Exportieren von Personen, die keine Funktion oder Geschlecht angegeben haben",
            }, {
                "description": "Fehler bei der Erstellung von Zahlungsläufen behoben",
            }, {
                "description": "Fehlerhafte SEPA XML-Datei bei Zahlungsläufen korrigiert",
            }, {
                "description": "Fehlerbehebungen in KJP Formularen",
            }
        ]
    }, {
        release: "1.13.2",
        date: "2025-07-10",
        tags: [
            "Statistik"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Fehlerbehebung bei der Anzeige von Statistiken",
            }, {
                "description": "Fehlerbehebung beim Bearbeiten von Statistiken",
            }
        ]
    }, {
        release: "1.13.1",
        date: "2025-07-03",
        tags: [
            "Statistik"
        ],
        type: "minor",
        notes: [
            {
                "description": "\"Ausfüllen\"- und \"Verwalten\"-Rechte zu Statistikerhebungen hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung in Statistikformularen der Amtlichen Statistik",
            }
        ]
    }, {
        release: "1.13.0",
        date: "2025-07-03",
        tags: [
            "Vorgänge", "Statistik", "Mailvorlagen", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Hinweise zu abweichenden Daten zwischen Vorgang und Formular Daten in Vorgangsdetailseite eingefügt"
            }, {
                "description": "Neues Vorgangs-Tool \"E-Mail an Ansprechpersonen\" hinzugefügt"
            }, {
                "description": "Beim Absenden von Statistiken werden jetzt die Organisationsdaten auf Vollständigkeit geprüft"
            }, {
                "description": "Speichern von persönlichen Filtereinstellungen in der Vorgangsübersicht",
            }, {
                "description": "Vereinfachung der Nutzer*innen-Organisationsverknüpfung",
            }, {
                "description": "Statistikformulare überarbeitet",
            }, {
                "description": "Neue Variablen in Mailvorlagen hinzugefügt",
            }
        ],
        fixes: [
            {
                "description": "Löschen von E-Mailvorlagen wieder möglich",
            }, {
                "description": "Geldbeträge in Statusänderungsmails werden korrekt formatiert",
            }, {
                "description": "Fehler in Massengenehmigung von Vorgängen behoben",
            }, {
                "description": "Fehlerbehebung bei LJP Formularen",
            }, {
                "description": "Fehlerbehebung beim Neuanlegen von Statistiken",
            }, {
                "description": "Fehlerbehebung Zahlungslauf: SL-Nummer wurde mit laufender Nummer gefüllt",
            }, {
                "description": "Fehlerbehebung bei der Sichtbarkeit von Dokumenten im Verwaltungsbereich",
            }, {
                "description": "Fehler in Auswertungen behoben",
            }
        ]
    }, {
        release: "1.12.1",
        date: "2025-06-11",
        tags: [
            "Organisationen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Lange Ladezeit beim Speichern von Organisationen verringert",
            }
        ]
    }, {
        release: "1.12.0",
        date: "2025-06-11",
        tags: [
            "Zahlungen", "Vorgänge", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Layoutanpassung der Vorgangsdetailseite im Verwaltungsbereich"
            }, {
                "description": "Neue Variablen bei Mailvorlagen hinzugefügt"
            }, {
                "description": "Formulare können zu Veranstaltungen hinzugefügt werden, wenn das gleiche Formular schon vorhanden ist, jedoch storniert wurde"
            }, {
                "description": "Sport-Anbindung: Login hinzugefügt"
            }, {
                "description": "Sport-Anbindung: SAGE-Export für Zahlungen hinzugefügt"
            }, {
                "description": "Werkzeug Vorgänge: \"Status ändern\" hinzugefügt"
            }, {
                "description": "Verbandseinstellungen: verwenden der Bankverbindung in Formularen kann deaktiviert werden"
            }, {
                "description": "Generelle Layoutanpassungen"
            }, {
                "description": "AmosWEB Personenimport: es werden nur noch bestätigte Personen importiert"
            }, {
                "description": "Werkzeug Vorgänge: \"Massengenehmigung\" hinzugefügt"
            }, {
                "description": "Vorgangshistorie in Vorgangsdetailseite überarbeitet",
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Zurücksetzen des Passworts behoben",
            }, {
                "description": "Fehler bei Auswertung mit zu vielen Vorgängen behoben"
            }, {
                "description": "Fehler beim Versenden von Testmails behoben"
            }, {
                "description": "Fehlerbehebung in KJP-Formularen"
            }, {
                "description": "Fehler bei ausgeblendeten hochgeladenen Dokumenten in Formularen behoben"
            }, {
                "description": "Fehlerbehebung bei Versand von Statusänderungs-E-Mails",
            }, {
                "description": "Fehlerbehebungen beim Importieren von Personen aus Excel-Dateien",
            }, {
                "description": "Fehler beim Erzeugen von Zahlungslauf-Vorschau behoben",
            }, {
                "description": "Fehler bei globaler Suche behoben",
            }, {
                "description": "Kleinere Fehlerbehebungen bei Formularen",
            }, {
                "description": "Ausbleiben des Stornokommentars beim Stornieren von Vorgängen behoben",
            }
        ]
    }, {
        release: "1.11.0",
        date: "2025-04-17",
        tags: [
            "Statistik", "Vorgänge", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Statistik: Grundfunktionen implementiert"
            }, {
                "description": "Anpassung der LJP und KJP Formulare"
            }, {
                "description": "Abgeschickte Formulare können im Antragsbereich angeschaut werden"
            }, {
                "description": "Personen einer Veranstaltung können als Excel-Liste exportiert werden"
            }, {
                "description": 'Neuer Vorgangsstatus "Abgelehnt"',
            }, {
                "description": "Nutzer*innenmanagement ausgebaut: Organisationsadmin kann Nutzer*innen anlegen, ändern und löschen"
            }, {
                "description": "Vorgangsdokumente hinzugefügt zum nachträglichen Hinzufügen von Dokumenten zu einem Vorgang"
            }, {
                "description": "E-Mailvorlagen für Statusbenachrichtigungen können jetzt von Verbandsadmins angelegt werden"
            }, {
                "description": "Auswertungen LJP SV31 und SV32 angepasst"
            }, {
                "description": "Übertragung von Vorgängen, wenn Nutzer*innen gelöscht werden soll"
            }, {
                "description": "Gesammeltes Löschen von Nutzer*innen nicht mehr möglich"
            }, {
                "description": "Mobile Ansicht der Website verbessert"
            }
        ],
        fixes: [
            {
                "description": "Fehler beim PDF-Export des durchgeführten Programms behoben",
            }, {
                "description": "Fehler beim Importieren von Personen behoben",
            }, {
                "description": "Fehler beim Speichern des deaktivierten Weitergabevertrags ohne Dokument behoben",
            }, {
                "description": "Fehlerbehebung beim Kopieren von Vorgängen"
            }
        ]
    }, {
        release: "1.10.0",
        date: "2025-03-26",
        tags: [
            "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Auswertung \"Sammelliste\" hinzugefügt"
            }, {
                "description": "ID- und Ort-Spalte in Organisationsübersicht hinzugefügt"
            }, {
                "description": "Abgeschickt-Datum im Verwaltungsbereich bei Vorgangsdetailansicht unter Formularen hinzugefügt"
            }, {
                "description": "Ausdrucken des Formulars im Verwaltungsbereich in Formulardetailansicht in Vorgangsdetailansicht hinzugefügt"
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung bei LJP Auswertungen",
            }
        ]
    }, {
        release: "1.9.0",
        date: "2025-03-25",
        tags: [
            "Suche", "Vorgänge", "Auswertungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Suche von Organisationen und Adressen angepasst"
            }, {
                "description": "Statusfilter in Vorgängen angepasst"
            }, {
                "description": "Text bei Server-Fehlermeldung angepasst"
            }, {
                "description": "Datum des Weitergabevertrags in Organisationsübersicht hinzugefügt"
            }, {
                "description": "SMP Zertifikate Auswertung angepasst"
            }, {
                "description": "SMP Zuschüsse Formular angepasst"
            }, {
                "description": "Personenzusatzfelder werden jetzt im Excel Import berücksichtigt"
            }, {
                "description": "LJP Auswertungen angepasst"
            }, {
                "description": "Vorgänge können jetzt kopiert werden"
            }, {
                "description": "Filter \"nur eigene Vorgänge\" aus Vorgangsübersicht entfernt"
            }
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Wechsel von Organisationen",
            }, {
                "description": "Fehlerbehebung beim automatischen Vergrößern von Textfeldern",
            }, {
                "description": "Fehlerbehebung beim Speichern von Verbänden ohne Weitergabevertragdokument",
            }
        ]
    }, {
        release: "1.8.0",
        date: "2025-02-27",
        tags: [
            "Auswertungen", "Formulare", "Vorgänge"
        ],
        type: "minor",
        notes: [
            {
                "description": "LJP SV22 Auswertung hinzugefügt"
            }, {
                "description": "LJP SV31 Auswertung hinzugefügt"
            }, {
                "description": "LJP SV32 Auswertung hinzugefügt"
            }, {
                "description": "LJP SV33 Auswertung hinzugefügt"
            }, {
                "description": "Layout-Anpassungen bei der Vorgangsbearbeitung"
            }, {
                "description": "KJP Formulare angepasst"
            }, {
                "description": "LJP V22-1 angepasst"
            }, {
                "description": "Verwaltungsbereich an mobile Ansicht angepasst"
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Importieren von Personen behoben",
            }, {
                "description": "Fehler beim Erstellen von Auswertungen behoben",
            }, {
                "description": "Fehlerbehebung bei Änderung von Veranstaltung: Datenübernahme in anderen Vorgängen der Veranstaltung",
            }
        ]
    }, {
        release: "1.7.0",
        date: "2025-02-21",
        tags: [
            "Auswertungen", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "SMP Zertifikate Auswertung angepasst"
            }, {
                "description": "SMP Ministerium Auswertung hinzugefügt"
            }, {
                "description": "Personen in Veranstaltungen können jetzt gesammelt gelöscht werden"
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Importieren von Personen behoben",
            }, {
                "description": "Fehlerbehebung bei Eingabe der Lehrgangsstunden pro Tag",
            }, {
                "description": "Fehler beim Bearbeiten von abgeschickten Formularen in Verwaltungsbereich behoben",
            }
        ]
    }, {
        release: "1.6.0",
        date: "2025-02-19",
        tags: [
            "Auswertungen", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "SMP Auswertung hinzugefügt"
            }, {
                "description": "Veranstaltungsfilter zu Vorgangstabelle hinzugefügt"
            }, {
                "description": "KJP OT Formular hinzugefügt"
            }, {
                "description": "Bildungskonzepte können mehrfach pro Verband angelegt werden"
            }, {
                "description": "Unterschriftprozess vereinfacht"
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Speichern von Vorgängen behoben",
            }, {
                "description": "Fehler bei Auswertungen behoben",
            }, {
                "description": "Fehlerbehebung bei PDF Formularen",
            }, {
                "description": "Fehler beim Anlegen von Organisationen behoben",
            }
        ]
    }, {
        release: "1.5.0",
        date: "2025-02-05",
        tags: [
            "Organisation", "Formulare", "Vorgänge"
        ],
        type: "minor",
        notes: [
            {
                "description": "Bildungskonzepte können in Verbandsorganisationen angelegt werden"
            }, {
                "description": "SMP-Formulare hinzugefügt"
            }, {
                "description": "Banner zur Anzeige des Systems hinzugefügt"
            }, {
                "description": "Formularspezifische Personenfelder können beim Excel-Import mit importiert werden"
            }, {
                "description": "Formularspezifische Personenfelder werden in Personen-Tabelle angezeigt"
            }, {
                "description": "In Formularklasse ist ersichtlich, welche Veranstaltungs- und Personenfelder abgefragt werden"
            }, {
                "description": "Filter nach Veranstaltungen mit Klick auf Veranstaltung in Vorgangstabelle hinzugefügt"
            }
        ],
        fixes: [
            {
                "description": "Fehler beim Filtern von Vorgängen nach Förderprogrammen behoben",
            }, {
                "description": "Fehler bei der \"Support geben\"-Funktion behoben",
            }, {
                "description": "Fehler bei Datumsauwahlfeld behoben",
            }, {
                "description": "Fehler beim Unterschreiben von Formularen behoben",
            }, {
                "description": "Fehler beim Importieren von Personen behoben",
            }, {
                "description": "Fehler bei Dateitypprüfung beim Upload von Dateien behoben"
            }
        ]
    }, {
        release: "1.4.0",
        date: "2025-01-21",
        tags: [
            "CMS", "Organisation", "Formulare", "Profil"
        ],
        type: "minor",
        fixes: [
            {
                "description": "Verbandshinweise werden nun korrekt aktualisiert.",
            }, {
                "description": "Fehler beim Löschen von Bankverbindungen behoben.",
            }, {
                "description": "Fehler beim Import von Personendaten aus Excel-Dateien behoben.",
            }, {
                "description": "Fehler beim Löschen von Formularen behoben.",
            }, {
                "description": "Fehler beim Zurücksetzen von Passwörtern behoben.",
            }
        ]
    }, {
        release: "1.3.0",
        date: "2025-01-15",
        tags: [
            "CMS", "Organisationen"
        ],
        type: "minor",
        notes: [
            {
                "description": "CMS: Startseite wird durch Inhalte von CMS gespeist"
            }, {
                "description": "CMS: Hinweise von Verbänden wird angezeigt"
            }
        ],
        fixes: [
            {
                "description": "Kategorien von Organisationen konnten nicht richtig gespeichert und gelöscht werden",
            }, {
                "description": "Diverse Fehlerbehebungen bei Formularen",
            }, {
                "description": "Anpassungen der Rollenrechte",
            }
        ]
    }, {
        release: "1.2.2",
        date: "2025-01-03",
        tags: [
            "Profil", "Organisationen"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Nutzer*innen mit mehreren Rollen konnten in manchen Rollen ihr Profil nicht bearbeiten"
            }, {
                "description": "Versteckte Validierungen verhinderten das Speichern von manchen Organisationen"
            }
        ]
    }, {
        release: "1.2.1",
        date: "2024-12-31",
        tags: [
            "Contentmanagement", "Softwaretests"
        ],
        type: "minor",
        notes: [
            {
                "description": "Verbände können jetzt eigenen Content auf oaseBW erstellen"
            }, {
                "description": "Überführung der Contentverwaltung in ein eigenes CMS-System"
            }, {
                "description": "Erweiterung der Softwaretests"
            }
        ],
        fixes: [
            {
                "description": "Korrekturen verschiedener Formulierungen"
            }
        ]
    }, {
        release: "1.2.0",
        date: "2024-12-23",
        tags: [
            "Projektstunden", "Verbände"
        ],
        type: "minor",
        notes: [
            {
                "description": "Tagesbasierte Stundeneingabe in Formularen"
            }, {
                "description": "Anzeige von Anmerkungen im Antragsbereich"
            }, {
                "description": "Einheitliche Darstellung der Organisationsauswahl"
            }
        ],
        fixes: [
            {
                "description": "Optimiertes Speichern großer Verbände"
            }
        ]
    }, {
        release: "1.1.1",
        date: "2024-12-23",
        tags: [
            "Nutzer*innen", "Profilbilder"
        ],
        type: "bugfix",
        fixes: [
            {
                "description": "Fehler bei der Nutzer*innenbearbeitung behoben"
            }, {
                "description": "Fehlendes Laden von Profilbilder"
            }, {
                "description": "Anpassungen der Darstellung des Livesystems"
            }
        ]
    },
    {
        release: "1.1.0",
        date: "2024-12-20",
        tags: [
            "Formulare", "Verbände"
        ],
        type: "minor",
        notes: [
            {
                "description": "Formulare: KJP KT eingebaut"
            }, {
                "description": "Formulare: KJP PW eingebaut"
            }, {
                "description": "Formulare: KJP FB eingebaut"
            }, {
                "description": "Formulare: KJP FBR eingebaut"
            }, {
                "description": "Formulare: KJP TDO eingebaut"
            }, {
                "description": "Verbandseinstellungen mit digitaler Unterschrift erweitert"
            }
        ],
        fixes: [
            {
                "description": "Kleinere Layout-Anpassungen"
            }, {
                "description": "Kleinere Fehlerbehebungen"
            }
        ]
    }, {
        release: "1.0.0",
        date: "2024-12-19",
        tags: [
            "Auswertungen", "Formulare", "Organisationen"
        ],
        type: "major",
        notes: [
            {
                "description": "Auswertungen eingebaut"
            }, {
                "description": "Formulare: LJP A10 und V10 eingebaut"
            }, {
                "description": "Formulare: LJP A6.2 und V6.2 eingebaut"
            }, {
                "description": "Formulare: LJP A7.2 und V7.2 eingebaut"
            }, {
                "description": "Formulare: LJP A8.2 und V8.2 eingebaut"
            }, {
                "description": "Formulare: LJP A21-1 und V21-1 eingebaut"
            }, {
                "description": "Formulare: LJP A22-1 und V22-1 eingebaut"
            }, {
                "description": "Formulare: LJP A31-1 und V31-1 eingebaut"
            }, {
                "description": "Formulare: LJP A32-1 und V32-1 eingebaut"
            }, {
                "description": "Formulare: KVJS AAH und VAH eingebaut"
            }, {
                "description": "Formulare: KVJS AAJ und VAJ eingebaut"
            }, {
                "description": "Formulare: KVJS AFB und VFB eingebaut"
            }, {
                "description": "Formulare: KVJS AIA und VIA eingebaut"
            }, {
                "description": "Formulare: SZ NB eingebaut"
            }, {
                "description": "Vorbereitungen für Live-System"
            }, {
                "description": "Organisationen: Auth-Code eingebaut"
            }, {
                "description": "Organisationen: Struktur angepasst an RP und Verbände"
            }, {
                "description": "Organisationen: Verbandseinstellungen eingebaut"
            }
        ],
        fixes: [
            {
                "description": "Diverse Layout-Anpassungen"
            }, {
                "description": "Diverse Fehlerbehebungen"
            }
        ]
    }, {
        release: "0.10.0",
        date: "2024-10-23",
        tags: [
            "E-Mails", "Vorgänge", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "LJP A33-1 und V33-1 eingebaut"
            }, {
                "description": "Vorgangsdetailseite ausgebaut: Historieneinträge erweitert"
            }, {
                "description": "SL-Nummer in Vorgängen eingebaut"
            }, {
                "description": "Weitergabevertrag: Layout angepasst für klarere Kommunikation"
            }, {
                "description": "Zahlungsläufe: Anpassung der Liste aller Zahlungsläufe"
            }, {
                "description": "E-Mails ausgebaut: Status der E-Mails wird über Webhooks von Brevo nachverfolgt"
            }, {
                "description": "E-Mails ausgebaut: Übersicht über alle E-Mails für Systemadministratoren eingebaut"
            }, {
                "description": "E-Mails ausgebaut: Fehlgeschlagene E-Mails können erneut versendet werden"
            }, {
                "description": "Dashboard eingeführt"
            }, {
                "description": "Modulfarben eingeführt"
            }
        ],
        fixes: [
            {
                "description": "Layout-Anpassungen im kompletten System"
            }, {
                "description": "Ansprache im kompletten System auf \"Du\" geändert"
            }, {
                "description": "Kleinere Layout-Anpassungen"
            }, {
                "description": "Kleinere Fehlerbehebungen"
            }
        ]
    }, {
        release: "0.9.0",
        date: "2024-10-02",
        tags: [
            "Vorgänge", "Zahlungen", "Mailvorlagen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Zahlungen ausgebaut: Beim Erstellen werden fehlerhafte Vorgänge aussortiert"
            }, {
                "description": "Vorgangsdetailseite ausgebaut: Sichtung und Änderung von Formularen"
            }, {
                "description": "Mailvorlagen ausgebaut: Mailvorlagen können jetzt mit Status verknüpft werden"
            }, {
                "description": "Neue Filter in der Vorgangsübersicht im Verwaltungsbereich"
            }, {
                "description": "Personenliste-Export: Summenfelder hinzugefügt"
            }, {
                "description": "Weitergabevertrag ausgebaut: digital unterschreiben und Download möglich"
            }
        ],
        fixes: [
            {
                "description": "Fehlerhaftes Verhalten des Vorgangs-Menüs im Antragsbereich"
            }, {
                "description": "Fehlerhaftes Verhalten der Auswahl von Personen im Antrag"
            }, {
                "description": "Kleinere Layout-Anpassungen"
            }
        ]
    }, {
        release: "0.8.0",
        date: "2024-09-19",
        tags: [
            "Vorgänge", "Zahlungen", "Mailvorlagen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Zahlungen implementiert"
            }, {
                "description": "Vorgangsdetailseite ausgebaut: Sichtbarkeit von Vorgangsfeldern"
            }, {
                "description": "Mailvorlagen implementiert"
            },
        ],
        fixes: [
            {
                "description": "Fehlende Kategorieeinträge in der Historie von Organisationen implementiert"
            }, {
                "description": "Fehlender Export der Personenliste beim Vorgangsexport implementiert"
            }, {
                "description": "Fehlerbehebung beim Absenden von nicht unterschriebenen Formularen"
            }, {
                "description": "Fehlerbehebung beim Hochladen von Dateien in einem Formular"
            }, {
                "description": "Fehlerbehebung beim Speichern von neuen Organisationen und deren vererbten Kategorien der Elternorganisationen"
            }
        ]
    }, {
        release: "0.7.0",
        date: "2024-07-25",
        tags: [
            "Vorgänge", "Berechtigungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Berechtigungen ausgebaut: Sichtbarkeiten bei PDF-Export"
            }, {
                "description": "Berechtigungen ausgebaut: Sichtbarkeit von Dokumenten"
            }, {
                "description": "Vorgangsdetailseite im Verwaltungsbereich implementiert"
            },
        ],
        fixes: [
            {
                "description": "Fehlerbehebung beim Supporten von Nutzer*innen (impersonate)"
            }
        ]
    }, {
        release: "0.6.0",
        date: "2024-06-25",
        tags: [
            "Vorgänge", "Kategorien", "Berechtigungen"
        ],
        type: "minor",
        notes: [
            {
                "description": "Kategorien für Organisationen implementiert"
            }, {
                "description": "Verknüpfung von Kategorien und Organisationen"
            }, {
                "description": "Berechtigungen für Förderprogramme implementiert"
            }, {
                "description": "Vorgangsübersicht implementiert"
            },
        ],
        fixes: [
            {
                "description": "Behebung Anzeigefehler JugendZählt"
            }, {
                "description": "Fehlerbehebung beim Wechseln der aktiven Organisation"
            }
        ]
    }, {
        release: "0.5.0",
        date: "2024-05-29",
        tags: [
            "Formulare", "Mobile Ansicht", "Rollen", "Jahre"
        ],
        type: "minor",
        notes: [
            {
                "description": "Programmnachweis im Antrag implementiert"
            }, {
                "description": "Automatische Auswahl von Personen im Antrag implementiert"
            }, {
                "description": "Jahresverwaltung konzeptioniert und implementiert"
            }, {
                "description": "Rollenverwaltung konzeptioniert und implementiert"
            }, {
                "description": "Zusatzfelder für Personendaten abhängig von Formular implementiert"
            }, {
                "description": "Mobile Ansicht im Antrag"
            }, {
                "description": "Fehlermeldungen im Antrag verbessert"
            }, {
                "description": "Personenimport aus Excel oder amosWEB implementiert"
            },
        ],
        fixes: [
            {
                "description": "Fehlerhafte Adresssuche"
            }, {
                "description": "Fehlerhafte Suche in Auswahlfeld"
            }
        ]
    }, {
        release: "0.4.0",
        date: "2024-04-23",
        tags: [
            "Status", "Layouts", "Jugend Zählt"
        ],
        type: "minor",
        notes: [
            {
                "description": "Status Konzept ausgearbeitet und implementiert"
            }, {
                "description": "Standard Bankverbindungen"
            }, {
                "description": "Layout Vorgangsübersicht"
            }, {
                "description": "Anpassung UX 'Event-Box' im Antrag"
            }, {
                "description": "Jugend Zählt 2 Statistik"
            },
        ],
        fixes: [
            {
                "description": "Fehlerhafte Kommaprüfung"
            }
        ]
    }, {
        release: "0.3.0",
        date: "2024-04-03",
        tags: [
            "Formulare", "Layouts", "Struktur"
        ],
        type: "minor",
        notes: [
            {
                "description": "Umbau Layout Formulare/Antragsübersicht"
            }, {
                "description": "Neues Layout in Antragsseiten"
            }, {
                "description": "Erweiterung der Maßnahmen/Teilnehmenden"
            }, {
                "description": "Erweiterte Projektstruktur"
            }, {
                "description": "Neue Seite für abgesendete Formulare"
            }, {
                "description": "Weitere Formulare hinzugefügt"
            },
        ],
        fixes: [
            {
                "description": "Fehlerbehandlung in Adressauswahl"
            }
        ]
    }, {
        release: "0.2.0",
        date: "2024-03-26",
        tags: [
            "Grundsystem", "Stammdaten", "Formulare"
        ],
        type: "minor",
        notes: [
            {
                "description": "Einstellungen zu Stammdaten (Förderprogramme, Formulare)"
            }, {
                "description": "Separate Seiten/Layouts für Anträge"
            }, {
                "description": "Neue Landingpage"
            }, {
                "description": "Umsetzung erster Formulare"
            }, {
                "description": "Implementierung der grundlegenden Prozesse"
            }, {
                "description": "Bearbeitung von Maßnahmen und Personen"
            }, {
                "description": "Erweitertes Organisationsmanagement"
            }, {
                "description": "Adressdaten und -eingaben"
            }
        ]
    }, {
        release: "0.1.0",
        date: "2023-10-19",
        tags: [
            "Grundsystem"
        ],
        type: "minor",
        notes: [
            {
                "description": "Erste Fertigstellung des Grundsystems"
            }
        ]
    }, {
        release: "0.0.0",
        date: "2023-09-01",
        tags: [
            "Projektstart"
        ],
        type: "major",
        notes: [
            {
                "description": "Das Projekt wurde aufgesetzt. Die Entwicklung kann beginnen!"
            }
        ]
    }
]